
import BatteryDisable from "../../../assets/filled/BatteryDisable.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BatteryDisableIcon({ className, dataTestid = "BatteryDisableIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BatteryDisable data-testid={dataTestid} className={classes} {...rest} />
  );
}
